import axios from 'axios';
import { API_ENDPOINTS } from './apiEndpoints';
import { BASE_URL, apiRequest } from '../apiSettings';

export const signup = async (email: string, password: string, name: string) => {
    return apiRequest('post')('/signup', { email, password, name });
};

export const login = async (email: string, password: string) => {
    return apiRequest('post')('/login', { email, password });
};

export const checkIsLoggedIn = async () => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        return false;
    }
    try {
        const response = await axios.post(API_ENDPOINTS.VERIFY_USER, { token });
        return response.data["message"] == "success";
    } catch (err) {
        console.log('Login failed. Please check your credentials.');
        console.log(err);
        localStorage.removeItem('jwt-token');
        return false;
    }
};

export const getLoggedInUserName = async () => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        return "";
    }
    try {
        const response = await axios.post(API_ENDPOINTS.GET_USERNAME, { token });
        return response.data["username"];
    } catch (err) {
        console.log('Login failed. Please check your credentials.');
        console.log(err);
        localStorage.removeItem('jwt-token');
        return false;
    }
};

export const checkIsAdmin = async () => {
    const token = localStorage.getItem('jwt-token');
    if (!token) {
        return false;
    }

    const apiClient = axios.create({
        baseURL: BASE_URL,
        headers: {
            Authorization: `Bearer ${token}`
        },
    });

    try {
        const response = await apiClient.post(API_ENDPOINTS.VERIFY_USER_IS_ADMIN);
        return response.data["message"] == "success";
    } catch (error: any) {
        return false;
    }
};